import { MouseEventHandler, useContext } from 'react'

import { CartContext } from '@lib/cart'
import { StringsContext } from '@lib/strings-context'

import Alert from '@components/alert'
import Button from '@components/buttons/button'
import ComplexPortableText from '@components/portable-text/complex'

interface BundleAddToCartButtonProps {
  onClick: MouseEventHandler<HTMLButtonElement>
  isAddToCartError: boolean
}

const BundleAddToCartButton = ({
  onClick,
  isAddToCartError,
}: BundleAddToCartButtonProps) => {
  const { cart, isCartProductAdding } = useContext(CartContext)
  const strings = useContext(StringsContext)

  return (
    <>
      <Button
        id="bundle-add-to-cart-button"
        variant="primary"
        onClick={onClick}
        disabled={!cart || isCartProductAdding || isAddToCartError}
      >
        {isCartProductAdding && strings.buttonAdding}
        {cart &&
          !isCartProductAdding &&
          !isAddToCartError &&
          strings.buttonAddToCart}
      </Button>

      {isAddToCartError && (
        <div key="error" className="mt-6">
          <Alert error>
            <ComplexPortableText
              content={strings.cartAddToCartErrorMessage}
              className="rc rc-error"
            />
          </Alert>
        </div>
      )}
    </>
  )
}

export default BundleAddToCartButton
